var _defs, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 220 192",
    width: 220,
    height: 192,
    fill: "none",
    className: "absolute -top-16 -right-16 text-gray-700 ng-tns-c131-1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    className: "ng-tns-c131-1"
  }, /*#__PURE__*/React.createElement("pattern", {
    id: "837c3e70-6c3a-44e6-8854-cc48c737b659",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    patternUnits: "userSpaceOnUse",
    className: "ng-tns-c131-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 4,
    height: 4,
    fill: "currentColor",
    className: "ng-tns-c131-1"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 192,
    fill: "url(#837c3e70-6c3a-44e6-8854-cc48c737b659)",
    className: "ng-tns-c131-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.0926b255f6d5c39586bf6c1745f5dcaa.svg";
export { ForwardRef as ReactComponent };